<template>
    <div class="flex-fill flex-column no-scroll">
        <fe-crud
            ref="crud"
            :autoload="false"
            :config="$models.unknownAttendanceExcused"
            :readParams="{ upload_id: $props.uploadId }"
            @read="v => items = v"
        />

        <fe-mask v-show="loading" :showLoader="true" />

        <fe-dialog
            width="400"
            title="Create Excused Alias"
            v-if="dialog.show"
            @dismiss="dialog.show=false"
            @close="dialog.show=false"
            @accept="setAlias"
            acceptButtonText="Alias"
            :acceptButtonDisabled="!dialog.record"
            persistent
        >
            <v-form>
                <fe-label>Excused</fe-label>
                <v-autocomplete
                    :items="excuses"
                    v-model="dialog.record"
                    itemValue="id"
                    itemText="name"
                    required
                    flat solo dense
                />
            </v-form>
        </fe-dialog>

        <fe-grid
            :columnDefs="columns"
            :rowData="items"
            class="flex-grow-1"
            displayDensity="small"
            ref="grid"
            :showAddRowBtn="false"
            @selectionChanged="selectRow"
            @cellValueChanged="sanitize"
            showToolbar
        >
            <template v-slot:toolbar-items>
                <fe-btn usage="primary" v-if="canSave" @click="doSave">Save</fe-btn>

                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <fe-btn usage="primary" v-on="on" :disabled="!selections.length">
                            Actions
                        </fe-btn>
                    </template>

                    <v-list>
                        <v-list-item v-for="(item, index) in tools" :key="index" @click="item.handler()">
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </fe-grid>
    </div>
</template>

<script>
    export default {
        name: 'UnknownAttendanceExcused',
        props: {
            uploadId: {
                required: true
            }
        },
        data() {
            let me = this

            return {
                loading: false,
                canSave: false,
                selections: [],
                excuses: [],
                items: [],
                dialog: {
                    show: false,
                    record: null
                },
                pendingText: '<br><p class="caption mt-2">This will also save any pending changes.</p>',
                originalItems: [],
                tools: [{
                //     title: 'Create new Code',
                //     description: 'Add a new attendance excused code to eduCLIMBER',
                //     handler() {
                //         me.$confirmCreate(me.selections, () => {
                //             me.selections.forEach(rec => {
                //                 rec.new_attendance_excused = true
                //             })
                //             me.doSave()
                //         })
                //     }
                // }, {
                    title: 'Alias to Excused',
                    description: 'Set this code name as an alternate known name for a selected code',
                    handler() {
                        me.dialog.show = true
                    }
                }],
                columns: []
            }
        },
        watch: {
            items(v) {
            }
        },
        mounted() {
            this.loadAttendanceExcused()
        },
        methods: {
            doSave() {
                let dirty = this.$isDirty(this.originalItems, this.items)
                this.loading = true
                this.$refs.crud.update(dirty)
                    .then(response => {
                        this.loadAttendanceExcused()
                    })
                    .finally(() => { 
                        this.loading = false 
                    })
            },
            setAlias() {
                let me = this
                this.dialog.show = false
                this.selections.forEach(rec => { rec.matched_attendance_excused_id = this.dialog.record })
                
                this.sanitize()
                this.$refs.grid.gridApi.deselectAll()
                this.doSave()
            },
            selectRow(row) {
                this.selections = this.$refs.grid.gridApi.getSelectedRows()
            },
            sanitize() {
                // this will check to see if the original fetched data set has been manipulated
                let dirty = this.$isDirty(this.originalItems, this.items)
                if (dirty) {
                    this.canSave = true
                } else {
                    this.canSave = false
                }
                // Since we are changing cells behind the ag-grid api, call refresh
                this.$refs.grid.gridApi.refreshCells()
            },
            loadAttendanceExcused() {
                let me = this
                let id = this.$props.uploadId
                this.originalItems = []
                this.items = []

                this.loading = true
                this.$modelGet('attendanceCodes')
                    .then(response => {
                        this.excuses = response

                        this.columns = [me.$grid.checkColumn(), {
                            headerName: 'Import Excused Code',
                            field: 'name',
                            sortable: true,
                            flex: 1
                        }, {
                            headerName: 'Alias To',
                            field: 'matched_attendance_excused_id',
                            editable: true,
                            flex: 1,
                            tooltipValueGetter: (param) => 'This code will also be known as the selected code in eduCLIMBER',
                            cellRenderer: v => {
                                if (v.value) {
                                    let r = me.excuses.find(rec => { return rec.id == v.value })
                                    if (r) return r.name
                                }
                                return ''
                            },
                            cellEditorFramework: "FeGridChipSelect",
                            cellEditorParams: {
                                rowDataKey: "matched_attendance_excused_id",
                                mode: "edit",
                                items: me.$data.excuses,
                                keyProp: "id",
                                labelProp: "name",
                                disableChips: true
                            }
                        }]
                        this.$refs.crud.read()
                            .then(() => {
                                this.items.forEach(rec => {
                                    rec.matched_attendance_excused_id   = undefined
                                    rec.new_attendance_excused = false
                                })
                                this.originalItems = this.$_.cloneDeep(this.items)
                                this.$emit('count', this.originalItems.length)
                            })
                            .finally(() => { 
                                this.loading = false 
                                this.sanitize()
                            })
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>